<template>
    <div>
        <NuxtLayout>
            <template #body_page>
                <CGTTopBar />
                <CGTHero />
                <CGTDifference />
                <CGTBenefits />
                <CGTHowItWorks />
                <CGTContact />
                <CGTReviews :reviews-data="reviewsData" />
                <CGTFAQ />
            </template>
        </NuxtLayout>
        <ClientOnly>
        <teleport to="head">
            <component :is="'script'" type="application/ld+json">
                {{ ldJson }}
            </component>
        </teleport>
        </ClientOnly>
    </div>
</template>

<script setup>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import CGTTopBar from '~/components/pages/LandingPage/CGTTopBar'
import CGTHero from '~/components/pages/LandingPage/CGTHero/CGTHero.vue'
import CGTDifference from '~/components/pages/LandingPage/CGTDifference/CGTDifference.vue'
import CGTBenefits from '~/components/pages/LandingPage/CGTBenefits/CGTBenefits.vue'
import CGTContact from '~/components/pages/LandingPage/CGTContact.vue'
import CGTHowItWorks from '~/components/pages/LandingPage/CGTHowitWorks/CGTHowItWorks.vue'
import CGTReviews from '~/components/pages/LandingPage/CGTReviews/CGTReviews.vue'
import CGTFAQ from '~/components/pages/LandingPage/CGTFAQ/CGTFAQ.vue'
import metaData from '~/assets/meta_data.json'
// import { onMounted, ref } from 'vue'
import { computed, onMounted } from 'vue'
import localDesignerApi from '~/composables/api/localDesignerApi'

const reviewsData = ref([])
onMounted(() => {
  debounceAmplitudeScriptTracking("View Private Group Tours")
})
// useHead({
//     title: metaData.private_group_tours.title,
//     meta: [
//       {
//         name: `title`,
//         content: metaData.private_group_tours.title,
//       },
//       {
//         name: `description`,
//         content: metaData.private_group_tours.description,
//       },
//     ]
// })

const ldJson = {
    '@type': 'WebSite',
    '@id': 'https://www.designerjourneys.com/private-group-tours/#website',
    url: 'https://www.designerjourneys.com/private-group-tours',
    name: 'Private Group Tours: Tailor Made Journeys for You and Your Clients | Designer Journeys',
    description:
        'Welcome to Private Group Tours by Designer Journeys, a unique offering exclusively designed for busy travel agents who would like help designing private group tours for their clients.',
    potentialAction: [
        {
            '@type': 'AskAction',
            name: 'Design your trip',
            target: {
                '@type': 'EntryPoint',
                urlTemplate:
                    'https://agent.designerjourneys.com/design/group-trip-details',
                inLanguage: 'en-US',
                actionPlatform: [
                    'http://schema.org/DesktopWebPlatform',
                    'http://schema.org/MobileWebPlatform',
                ],
            },
        },
    ],
    inLanguage: 'en-US',
}
const fetchTravellerReviews = async (params) => {
    try {
        const {data} = await localDesignerApi.getTravellerReviews(params)
        reviewsData.value = data.value.data
    }
    catch (error) {
        console.log(error)
    }
}

// onMounted(async() => {
//     try {
//         const {data} = await localDesignerApi.getTravellerReviews({ designer_id: -1})
//         reviewsData.value = data.value.data
//     }
//     catch (error) {
//         console.log(error)
//     }
// })
await fetchTravellerReviews({ designer_id: -1})
</script>

<style lang="scss" scoped></style>
